<template>
  <div class="invitein" :style="'background-image:url('+img.pagebg+');height:'+winHeight+'px;background-size: 100% '+winHeight+'px;'">
    <div class="div_mask">
      <!-- <div class="f-16 f-w" style="padding-top: 80px;color: #ffffff;">{{otherinfo.username}} 邀请您参加</div> -->
      <div class="f-16" style="padding-top: 80px;align-items: center;color: #4A4A4A;">「凌志范儿」诚挚地邀请您参加 </div>
      <div class="f-16" style="align-items: center;display: inline-flex;color: #4A4A4A;"><img class="sficon" :src="img.sficon">  影响力认证</div>
      <!-- <div class="f-12" style="margin-top: 20px;padding: 0 45px;color: #EEEEEE;text-align: left;">获得影响力认证标识，发布动态会获得更多曝光展示。
        获得受邀参与活动、新闻投稿、提问与回答。
      获得更多权益与专属勋章。</div>
      <div>
        <img class="qrcode" :src="img.lexus">
      </div>
      <div class="f-12" style="color: #999999;margin-bottom: 30px;">长按保存凌志范儿微信</div> -->
      <div class="invitebtn" @click="invitein">认证入口</div>
    </div>
  </div>
</template>
<script>
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Grid, GridItem,Field,Button,Icon } from 'vant';
  export default {
    data () {
      return {
        winHeight:568,
        otherinfo:'',
        img:{
          sficon: require('../../../assets/img/lexus/approve/newicon.png'),
          lexus: require('../../../assets/img/lexus/approve/qrcode.png'),
          pagebg:require('../../../assets/img/lexus/approve/approve_bg.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      var h = document.documentElement.clientHeight || document.body.clientHeight;
      this.winHeight=h
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: false})
      this.$appService.isTabbar({state: true})
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      if(this.$route.query.token){
        this.source = this.$route.query.source
        this.token = this.$route.query.token
        this.user_id = this.$route.query.userid
        // this.otherid = this.$route.query.otherid
        this.$store.dispatch('param/setToken', this.$route.query.token)
        // this.getUserOther(this.$route.query.otherid)
        this.getActivity(this.$route.query.userid)
      }else{
        this.source = this.$route.params.source
        this.token = this.$route.params.token
        this.$store.dispatch('param/setToken', this.$route.params.token)
        this.user_id = this.$route.params.user_id
        this.getActivity(this.$route.params.user_id)
      }
      
      var params={
        event_code: '邀请认证',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/Approve/LexusInvitein.vue',
        user_id: this.user_id ? this.user_id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){

        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getActivity(id){
        var params={
          user_id:parseInt([id]),
        }
        common.getActivity(params,11).then(res => {
          if(res.data.state==1){
            this.activeinfo=res.data.data
            if(res.data.data.enroll_share_pic){
              this.img.lexus=res.data.data.enroll_share_pic
            }
            if(res.data.data.enroll_background_pic){
              this.img.pagebg=res.data.data.enroll_background_pic
            }
            
            if(res.data.data.is_enroll==1){
              wx.miniProgram.reLaunch({url: '/pages/webview/webview?scene=https://m.motortime.com/lexus/inviteok'})
            }
          }
        })
      },
      getUserOther(id){
        var params={
          user_id:parseInt([id]),
          source:this.source
        }
        member.userOther(params).then(res => {
          if(res.data.state==1){
            this.otherinfo=res.data.data
          }
        })
      },
      invitein(){
       if(this.token){
        if(this.source==9){
          wx.miniProgram.navigateTo({url: '/pages/webview/webview?scene=https://m.motortime.com/lexus/invite'})
        }else if(this.source==1){
          this.$router.push({name:'LexusInvite',params:{source:this.source,token:this.token,user_id:this.user_id}});
        }else{
          var params={
            url:this.weburl+'/lexus/invite?source='+this.source ,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }
      }else{
        wx.miniProgram.navigateTo({url: '/pages/login/login?url=https://m.motortime.com/lexus/invitein'})
      }
    }
  },
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Field.name]:Field,
    [Button.name]:Button,
    [Icon.name]:Icon
  }
}
</script>
<style lang="scss">
.invitein{
  text-align: center;
  width: 100%;
  .div_mask{
    width: 100%;
    height: 100%;
    // background: rgba(0,0,0,.8);
  }
  .sficon{
    width: 18px;
    height: 18px;
    margin-right: 3px;
  }
  .qrcode{
    width: 160px;
    height: 160px;
    margin-top: 30px;
    margin-bottom: 5px;
  }
  .invitebtn{
    font-size: 14px;
    text-align: center;
    background: #605C6B;
    color: #fff;
    padding:15px 30px;
    position: fixed;
    top: 73%;
    left: 34%;
  }

}
</style>
